import { DenuncianteXFamiliar } from './DenuncianteXFamiliar';
import { Persona } from './Persona';
import { TipoDenunciante } from './TipoDenunciante';
import { DenuncianteXRepLegal } from './DenuncianteXRepLegal';
import { Entidad } from './Entidad';
import { Departamento } from './Departamento';
import { Provincia } from './Provincia';
import { Distrito } from './Distrito';

export class Denunciante {
    ndenuncianteId: Number;
    ndenuncianteIdtipden: number;
    ndenuncianteIdpersona: Number;
    cdenuncianteFlganonimo: string;
    cdenuncianteFlgnotelec = 'NO';
    cdenuncianteFlgreprelegal: string;
    ndenuncianteIdempragrup: Number;
    ndenuncianteIdfur: Number;
    cdenuncianteFlgtrabentden = 'NO';
    cdenuncianteFlgmedidaprotec = 'NO';
    cdenuncianteFlgfamtrab = 'NO';

    cdenuncianteDscdirecc: string;
    cdenuncianteCdepartdomic: string;
    cdenuncianteCprovdomic: string;
    cdenuncianteCdistdomic: string;
    cdenuncianteCreferenciadomic: string;
    cdenuncianteDsccorreo: string;
    ndenuncianteIdmedionotif: number;
    cdenuncianteDsctelef: string;
    cdenuncianteDscmovil: string;
    cdenuncianteFlgacepmedpyb = 'NO';
    cdenuncianteFlgconfleyprot = 'NO';
    cdenuncianteDscagrup: string;
    listaDenunciantePorFamiliar: DenuncianteXFamiliar[];
    listaDenunciantePorReplegal: DenuncianteXRepLegal[];
    persona: Persona;
    personaComplemento: Persona;

    ndenuncianteIdperscompl: number;
    cdenuncianteDscrefdomccompl: string;
    cdenuncianteCodmodopresent: string;
    cdenuncianteDscdirecccompl: string;
    cdenuncianteDsccorreocompl: string;
    cdenuncianteDsctelefcompl: string;
    cdenuncianteDscmovilcompl: string;
    cdenuncianteCdepartcompl: string;
    cdenuncianteCprovcompl: string;
    cdenuncianteCdistcompl: string;
    cdenuncianteCodentcompl: string;
    cdenuncianteDscotroscompl: string;

    cdenuncianteCdeptent: string;
    cdenuncianteCprovent: string;
    cdenuncianteCdistent: string;
    cdenuncianteDscdireccent: string;
    cdenuncianteDscrefcent: string;


    cdenuncianteFlgsinruc = 'NO';


    // nUEVOS MOCJUP
    ndenuncianteIdrangoedad: number = null; // rangoEdad
    cdenuncianteCodsexo: string; // flgEsServidorPublico
    cdenuncianteFlgservpub = 'NO'; // flgEsTestigoHecho
    cdenuncianteFlgtestigoh = 'NO'; // flgAccesoInformacion
    cdenuncianteFlgaccdirinf = 'NO'; // flgAccesoInformacion
    cdenuncianteDscenterohecho: string; // dscEnteroHecho;
    tipoDenunciante: TipoDenunciante;
    entidadCompl: Entidad;
    departamentoCompl: Departamento;
    provinciaCompl: Provincia;
    distritoCompl: Distrito;

    cdenuncianteFlgautemail = 'NO';
    cdenuncianteFlgautacto = 'NO';
    cfurRangoEdad: any;
}
